import { useRef, useCallback, useEffect } from 'react';
import { isBrowser } from '../common/isBrowser.mjs';

function useTimeout({
  clearOnNewTimeout = false
} = {}) {
  const timeoutIds = useRef([]);
  const clearTimeout = useCallback(() => {
    if (!isBrowser()) {
      return;
    }
    if (timeoutIds.current.length > 0) {
      timeoutIds.current.forEach((id) => {
        window.clearTimeout(id);
      });
    }
  }, []);
  const setTimeout = useCallback(
    (callback, delay) => {
      if (!isBrowser()) {
        return;
      }
      if (clearOnNewTimeout) {
        clearTimeout();
      }
      const newId = window.setTimeout(() => {
        callback();
        timeoutIds.current = timeoutIds.current.filter((id) => id !== newId);
      }, delay);
      timeoutIds.current.push(newId);
    },
    [clearOnNewTimeout, clearTimeout]
  );
  useEffect(() => {
    return clearTimeout;
  }, [clearTimeout]);
  return {
    setTimeout,
    clearTimeout
  };
}

export { useTimeout as default };
//# sourceMappingURL=useTimeout.mjs.map
